export default __webpack_public_path__ + "static/media/s8.85c576bb.png";